module.exports = __webpack_public_path__ + "static/media/follow-up-boss.78daa577.png";